<template>
    <card class="card-stats" :gradient="gradient" :show-footer-line="true">
        <p class="mt-3 mb-0 text-sm">
            <slot name="header"></slot>
        </p>
        <div class="row">
            <div class="col">
                <slot>
                    <h5 class="card-title text-uppercase text-muted mb-0" v-if="title">
                        {{ title }}
                    </h5>
                    <span v-if="loading"><img height="30" class="loader" src="img/loading.gif" alt="loader"></span>
                    <span class="h2 font-weight-bold mb-0" v-if="subTitle && !loading">{{
                            subTitle
                        }}</span>
                </slot>
            </div>

            <div class="col-auto" v-if="$slots.icon || icon">
                <slot name="icon">
                    <div
                        class="icon icon-shape text-white rounded-circle shadow"
                        :class="[`bg-${type}`, iconClasses]"
                    >
                        <i :class="icon"></i>
                    </div>
                </slot>
            </div>
        </div>

        <p class="mt-3 mb-0 text-sm">
            <slot name="footer"></slot>
        </p>
    </card>
</template>
<script>
import Card from "./Card.vue";

export default {
    name: "stats-card",
    components: {
        Card,
    },
    props: {
        loading: false,
        type: {
            type: String,
            default: "primary",
        },
        icon: String,
        cardType: String,
        gradient: String,
        title: String,
        subTitle: String,
        iconClasses: [String, Array],
    },
};
</script>
<style></style>
